<template>
<div>
    <div class="wrapper-xs m-b">
            <a class="pull-left m-r thumb-xs" href="/ukuya/default/profiles/view/canali">
                <img class="img-circle thumb-xs" src="https://ukuyadev.s3.amazonaws.com/default/organization/3/5939312014f90-1496920352.jpg">
            </a>
            <div class="clear">
                <a class="link" href="/ukuya/default/profiles/view/canali">
                    Super Canali Italian Fine Wear Designer &amp; Maker | Design of the year 2019                </a>
            </div>
        </div>      
        <a v-bind:href="activityLink" target="_blank" class="row m-n block">
            <div v-if="image" class="col-md-4 no-padder">
              <img class="img-full" v-bind:src="image">
            </div>
            
            <div class="col-md-8">
                <span v-if="activity.action_name=='wall' && object.comment" class="clear">
                    <span class="block m-b-sm">{{ object.comment }}</span>
                </span>
                <div v-else class="clear">
                    <span class="block m-b-sm commented-title">{{ object.title }}</span>
                    <small class="block commented-description">{{ object.description }}</small>
                </div>
            </div>            
        </a>
</div>
</template>

<script>
    export default {
        props: ['activity'],
        data(){
            return{
                activityLink : '',
                slug : ''
            }
        },
        mounted(){
            this.defineLink();
            // this.slug = this.object.slug ? this.object.slug : this.object.alias;
            // this.activityLink = `${window.user.community_url}/${window.user.community_domain}/default/post/view/${this.slug}`
        },
        computed: {
            object(){
                return this.activity.object ? this.activity.object : this.activity.content;
            },
            image(){
                return (this.activity.object && this.activity.object.avatar) ? this.activity.object.avatar : this.activity.content.avatar
            }
        },
        methods: {
            defineLink(){
                const baseLink = `${window.user.community_url}/${window.user.community_domain}/default/`;
                const slug = this.object.slug ? this.object.slug : this.object.alias;

                if(this.activity.object){
                    switch(this.activity.action_name){
                        case 'post_create':
                        case 'post_update':
                        case 'post_like':
                        case 'post_comment':
                        case 'post_comment_like':
                            this.activityLink = baseLink + `post/view/${slug}`;
                            break;
                        case 'media':
                            this.activityLink = baseLink + `corporate#/view/${this.activity.owner.id}/media`;
                            break;
                        case 'event_create':
                        case 'event_join':
                        case 'event_update':
                        case 'event_like':
                        case 'event_comment':
                        case 'event_comment_like':
                            this.activityLink = baseLink + `events/view/${slug}`;
                            break;
                        case 'wall':
                            this.activityLink = (this.object.type == 'article') ? this.object.url : '#';
                            break;
                        default:
                            this.activityLink = '#';
                            break;
                    }
                } else {
                    switch(this.activity.content_type){
                        case 'post':
                            this.activityLink = baseLink + `post/view/${slug}`;
                            break;
                        case 'event':
                            this.activityLink = baseLink + `events/view/${slug}`;
                            break;
                        case 'groups':
                            this.activityLink = baseLink + `groups/view/${slug}`;
                            break;
                        case 'blog':
                            this.activityLink = baseLink + `blog/view/${slug}`;
                            break;
                        case 'profile':
                            this.activityLink = baseLink + `profiles/view/${slug}`;
                            break;
                        default:
                            this.activityLink = '#';
                            break;
                    }
                }
            }
        }
    }
</script>

<style scoped>
@media only screen and (min-width: 1200px){
.commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}    
}
@media only screen and (max-width: 1199px) and (min-width: 1024px){
.commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
}
@media only screen and (max-width: 1023px) and (min-width: 768px){
.commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
}
@media only screen and (max-width: 767px){
.commented-title {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 16px;
    color: #3c4144;
    line-height: 21px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    }
.commented-description {
    display: block;
    display: -webkit-box;
    max-width: 100%;
    font-size: 14px;
    color: #777;
    line-height: 21px;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    }
}
</style>